import { InjectionToken } from '@angular/core';

export const REPORTING_BASE_V2: InjectionToken<string> = new InjectionToken(
  'REPORTING_BASE_V2'
);
